const publicUploadRoutes = ['Upload', 'UploadDistrict', 'genralUpload']

export function createNavigationGuard({ store, AuthService, storage }) {
  return async function navigationGuard(to, from, next) {
    await store.dispatch('routeInfo', { from, to })

    const authenticated = publicUploadRoutes.includes(to.name)
      ? false
      : new AuthService().authenticated
    const hasStoredUser = storage.getItem('user') !== null
    const isProjectRoute = to.matched?.some(route => route.path === '/projects/:name')

    if (isProjectRoute && !authenticated && to.name !== 'Donation') {
      return next({
        name: 'Donation',
        params: { name: to.params.name },
      })
    }

    if (isProjectRoute && authenticated && to.name !== 'AuditProject') {
      return next({
        name: 'AuditProject',
        params: { name: to.params.name },
      })
    }

    if (to.matched.some(route => route.meta.requiresAuth) && (!hasStoredUser || !authenticated)) {
      return next({
        path: '/session/login',
        query: { redirect: to.fullPath },
      })
    }

    if (to.matched.some(route => route.meta.restrictForFoginUser) && (hasStoredUser || authenticated)) {
      return next({ path: '/elections' })
    }

    return next()
  }
}
